import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpHelperService } from "src/app/shared/services/http-helper.service";

@Injectable()
export class LandingPageService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public getCarouselContent(body): Observable<any> {
    body.dashboardFlag = true;
    return this.httpHelperService.post(
      "/cms/site/structured-contents/contents",
      body,
    );
  }

  public saveQuickLink(body): Observable<any> {
    return this.httpHelperService.post("/home/quick-links", body);
  }

  public getDirectUrlFromSubMenu(body): Observable<any> {
    return this.httpHelperService.getDirectUrl(body);
  }

  public getAnnouncements(): Observable<any> {
    const params = new HttpParams().set("dashboardFlag", "true");
    return this.httpHelperService.get("/home/announcements", params);
  }

  public getUserPerformance(payload): Observable<any> {
    return this.httpHelperService.get(
      `/home/user-performance?userId=${payload.userId}&agentCode=${payload.agentCode}`,
    );
  }

  public getTotalOutstandingPremium(userId): Observable<any> {
    return this.httpHelperService.get(
      `/user/totaloutstandingpremium?userId=${userId}`,
    );
  }

  public getOutstandingCBcalert(userId): Observable<any> {
    return this.httpHelperService.get(
      `/user/outstandingcbcalert?userId=${userId}`,
    );
  }

  public getPolicyManagement(userId: string): Observable<any> {
    return this.httpHelperService.get(
      `/home/policy-management?userId=${userId}`,
    );
  }

  public fetchPostCodeInfo(code: string) {
    return this.httpHelperService.get(
      `/common/postcode/detail?postcode=${code}`,
    );
  }

  public getPolicyStats({ userId, skipLoading = false }): Observable<any> {
    return this.httpHelperService.get(
      `/home/dashboard?userId=${userId}&skipLoading=${skipLoading}`,
    );
  }

  public getLandingPageMenu(userId: string): Observable<any> {
    return this.httpHelperService.get(`/user/menuaccess?userId=${userId}`);
  }

  public sendQlData(payload: any): Observable<any> {
    return this.httpHelperService.post(`/home/quick-links`, payload);
  }
}
